export const PATH_CONNECT_MY_MOBILE_APP = "/connect-my-mobile-app";
